import { REF_DELIMITER } from '@wix/thunderbolt-byref'

// "ref1_r_ref2 => ["ref1", "ref1_r_ref2"]
export const getRefCompIds = (refCompId: string): Array<string> => {
	const res: Array<string> = []
	refCompId.split(REF_DELIMITER).forEach((refId, index) => {
		if (index > 0) {
			res.push(`${res[index - 1]}${REF_DELIMITER}${refId}`)
		} else {
			res.push(refId)
		}
	})
	return res
}
